import type { RouteRecordRaw } from "vue-router";

export const helpRoutes: RouteRecordRaw[] = [
  {
    path: "/help",
    name: "help-redirect",
    component: () => import("./HelpPage.vue"),
  },
  {
    path: "/help/limits",
    name: "help-limits-index",
    component: () => import("./limits/HelpLimitsPage.vue"),
  },
  {
    path: "/help/model_cards",
    name: "help-model-cards-index",
    component: () => import("./model_cards/HelpModelCardsPage.vue"),
  },
];
